import { render, staticRenderFns } from "./Rescue.vue?vue&type=template&id=6c8ee362&scoped=true&"
import script from "./Rescue.vue?vue&type=script&lang=js&"
export * from "./Rescue.vue?vue&type=script&lang=js&"
import style0 from "./Rescue.vue?vue&type=style&index=0&id=6c8ee362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ee362",
  null
  
)

export default component.exports